import { useEffect, useCallback } from 'react'
import { Modal, theme } from 'antd'
import { useBlocker } from 'react-router-dom'
import type { BlockerFunction } from 'react-router-dom'
import { useTranslate } from './translate'

export const useWarnUnsavedFormOnWindowUnload = (shouldBlock: boolean, shouldSkipChecking: boolean) => {
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (shouldBlock && !shouldSkipChecking) {
                event.preventDefault()
            }
        }

        addEventListener('beforeunload', handleBeforeUnload)

        return () => removeEventListener('beforeunload', handleBeforeUnload)
    }, [shouldBlock])
}

export const useWarnUnsavedFormOnAppNavigation = (isFormDirty: boolean, shouldSkipChecking: boolean) => {
    const { __ } = useTranslate()
    const { token: { colorPrimary } } = theme.useToken()

    const shouldBlock = useCallback<BlockerFunction>(
        ({ currentLocation, nextLocation}) => isFormDirty && currentLocation.pathname !== nextLocation.pathname,
        [isFormDirty]
    )

    const blocker = useBlocker(shouldBlock)

    useEffect(() => {
        if (blocker.state === 'blocked') {
            if (shouldSkipChecking) {
                blocker.proceed?.()
            } else {
                Modal.confirm({
                    title: __`unsaved_changes`,
                    content: __`you_have_unsaved_changes_are_you_sure_you_want_to_leave_this_page`,
                    okText: __`confirm`,
                    cancelText: __`cancel`,
                    okButtonProps: {
                        style: {
                            backgroundColor: colorPrimary
                        }
                    },
                    cancelButtonProps: {
                        style: {
                            border: 0,
                        }
                    },
                    onOk() {
                        blocker.proceed?.()
                    },
                    onCancel() {
                        blocker.reset?.()
                    }
                })
            }
        }
    }, [blocker])
}
